import "../stylesheets/displayMessage.scss";

export default function DisplayMessage() {
  return (
    <div className="display-message">
      <div className="display-container">
        <h1>
          This portion of the site is currently unavailable. Please check back
          soon.
        </h1>
      </div>
    </div>
  );
}
